import axios from 'axios';
import router from '@/router';
import baseConfig from '@/settings';
import { getCloudLang } from './fns';
import { debounce } from './index';

const cloudLang = getCloudLang();

const service = axios.create({
  baseURL: baseConfig.baseApi,
  timeout: 20000,
});

const getGlobalHeaderConfig = () => {
  const _header = {};
  _header['language'] = cloudLang;
  _header['accept-language'] = cloudLang;
  _header['autel-token'] = localStorage.getItem('token');
  return _header;
};

service.interceptors.request.use(
  config => {
    config.headers = config.headers || {};
    config.headers = {
      ...getGlobalHeaderConfig(),
      ...config.headers,
    };
    return config;
  },
  error => {
    console.log(error);
    return Promise.reject(error);
  },
);

service.interceptors.response.use(
  res => {
    const code = parseInt(res.data.code) || arrayBufferToJosn(res.data)?.code || 200;
    if (res.status !== 200) {
      // Http 状态码异常，跳转至异常页面
      if ([401, 10005001, 10001245, 10005002].includes(code)) {
        router.push('/error');
      }
      return Promise.reject(res);
    } else {
      // 登录过期，跳转至异常页面
      if ([401, 10005001, 10001245, 10005002].includes(code)) {
        router.push('/error');
      }
      return res.data;
    }
  },
  error => {
    return Promise.reject(error);
  },
);

export default service;
